import React from 'react';
import { IconButton, Popover } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import { Trans, useTranslation } from 'react-i18next';

type DietTypeInfoPopoverType = {
    dietType: string;
};

const DietTypeInfoPopover = (props: DietTypeInfoPopoverType) => {
    const { dietType } = props;

    const { t, i18n } = useTranslation();

    const [dietTypeInfoAnchorEl, setDietTypeInfoAnchorEl] =
        React.useState<HTMLButtonElement | null>(null);

    const handleDietTypeInfoClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setDietTypeInfoAnchorEl(event.currentTarget);
    };
    const handleDietTypeInfoClose = () => {
        setDietTypeInfoAnchorEl(null);
    };

    return (
        <>
            <IconButton onClick={handleDietTypeInfoClick}>
                <HelpIcon fontSize="small" color="secondary" />
            </IconButton>
            <Popover
                open={Boolean(dietTypeInfoAnchorEl)}
                anchorEl={dietTypeInfoAnchorEl}
                onClose={handleDietTypeInfoClose}
            >
                <div className="p-4 text-sm">
                    <Trans i18nKey={`diet-description_${dietType}` as string} />
                </div>
            </Popover>
        </>
    );
};

export default DietTypeInfoPopover;
